import React, { Component } from "react";

// Assets
import ProfilePic from "../../Assets/Thor.png";

// SetProfile Component
export default class SetProfile extends Component {
  render() {
    return (
      /* Profile Image Block */
      <div className="Profile_ProfilePic_Component">
        <div className="Profile_PicBlock">
          <img src={ProfilePic} alt="User Profile Picture" />
        </div>
        <div className="Profile_ChangeBtn"></div>
        <div className="Profile_UserTitleName">{this.props.name}</div>
      </div>
    );
  }
}
